import { Reveal, useSeo } from "../components/Shared";
import { EMAIL } from "../data/content";

const SECTIONS = [
  ["Information we collect", "We collect the information you share with us directly, such as your name, email address, phone number, organization and the content of your enquiries when you submit a consultation request, career application or internship application through this website."],
  ["How we use your information", "Your information is used solely to respond to your enquiry, evaluate applications, provide requested services and communicate relevant updates about Dishan International Group programs and services. We do not sell or rent personal information to third parties."],
  ["Data storage & security", "Submitted information is stored securely and access is limited to authorised members of the Dishan International Group team. We apply reasonable technical and organisational safeguards to protect your data against unauthorised access, alteration or disclosure."],
  ["Cookies & analytics", "This website may use basic analytics to understand how visitors use the site so we can improve the experience. Analytics data is aggregated and does not personally identify you."],
  ["Third-party links", "Our website may contain links to external platforms such as social media. We are not responsible for the privacy practices of those platforms and encourage you to review their policies."],
  ["Your rights", "You may request access to, correction of, or deletion of your personal information at any time by contacting us. We will respond to legitimate requests within a reasonable timeframe."],
  ["Updates to this policy", "We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised effective date. Continued use of the website after changes indicates acceptance of the updated policy."],
];

export default function Privacy() {
  useSeo(
    "Privacy & Policy | Dishan International Group",
    "How Dishan International Group collects, uses and protects your personal information."
  );
  return (
    <>
      <section className="page-hero">
        <div className="container">
          <Reveal>
            <span className="eyebrow">Legal</span>
            <h1>Privacy & Policy</h1>
            <p>Effective June 2026 · How we collect, use and protect your information.</p>
          </Reveal>
        </div>
      </section>
      <main>
        <section className="section">
          <div className="container narrow legal-body" data-testid="privacy-policy-content">
            <Reveal>
              <p>Dishan International Group ("we", "our", "us") respects your privacy. This policy explains what information we collect through this website, how we use it, and the choices you have.</p>
            </Reveal>
            {SECTIONS.map(([h, p], i) => (
              <Reveal key={h} delay={Math.min(i * 0.04, 0.2)}>
                <h2>{i + 1}. {h}</h2>
                <p>{p}</p>
              </Reveal>
            ))}
            <Reveal>
              <h2>Contact us</h2>
              <p>For any privacy-related questions or requests, write to us at <a href={`mailto:${EMAIL}`} data-testid="privacy-email-link">{EMAIL}</a>.</p>
            </Reveal>
          </div>
        </section>
      </main>
    </>
  );
}
